import { ReactNode } from 'react';
import { FooterLink } from '../FooterLink';

export interface CampusLinkProps {
  children: ReactNode;
  className?: string;
}

export const LinksAndCricos = ({ children }: CampusLinkProps) => {
  return (
    <div className="w-full lg:pr-8">
      <div className="w-full">
        <ul
          className="block w-full flex-shrink columns-2 flex-col flex-wrap justify-center gap-8 md:flex md:flex-row md:justify-start
            md:break-words md:text-left md:[&_a]:text-center lg:[&_a]:text-left space-y-2.5 md:space-y-0"
        >
          {children}
        </ul>
      </div>
      <div
        className="col-span-2 mt-8 flex w-full flex-col gap-3 md:flex-row md:space-x-6
          [&_span]:text-[clamp(0.75rem_,_0.63rem_+_0.46vw,_1rem)] sm:text-[14px] sm:leading-[21px]"
      >
        <span>ABN 99 143 842 569.</span>
        <span>CRICOS Provider Code 00301J.</span>
        <span>
          TEQSA{' '}
          <FooterLink
            to="https://www.teqsa.gov.au/national-register/provider/curtin-university-formerly-curtin-university-technology"
            label="PRV12158"
          />
        </span>
      </div>
    </div>
  );
};
